// import moment from 'moment'
export const forms = {
  getBaseForm(formData, extend, pageType) {
    var moren = ''
    if (pageType === 'increase' || pageType === 'edit') {
      moren = ''
    } else {
      moren = '--'
    }
    const getType = (name, type) => {
      if (extend.checkDisabled(name)) {
        return 'text'
      } else {
        return type
      }
    }
    const data = [
      {
        type: getType('need_help_person_family_number', 'input'),
        label: '家庭人数',
        col: '8',
        // disabled: extend.checkDisabled,
        id: 'need_help_person_family_number',
        defaultValue: formData.need_help_person_family_number || (getType('need_help_person_family_number', 'input') === 'text' ? '--' : ''),
        rules: [
          {
            pattern: /^\d{1,2}$/,
            message: '请输入正确的家庭人数'
          },
          {
            required: true,
            message: '请输入家庭人数'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('need_help_person_family_income', 'input'),
        label: '家庭年总收入',
        col: '8',
        defaultValue: formData.need_help_person_family_income || moren,
        rules: [
          {
            pattern: /^(([0-9]+.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*.[0-9]+)|([0-9]*[1-9][0-9]*)|0)$/,
            message: '请输入数字'
          }
        ],
        suffix: '元',
        id: 'need_help_person_family_income',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: getType('need_help_person_fmily_housing', 'input'),
      //   label: '家庭住房',
      //   col: '7',
      //   defaultValue: formData.need_help_person_fmily_housing,
      //   onChange: (value) => extend.numberChange(value, 'need_help_person_fmily_housing'),
      //   id: 'need_help_person_fmily_housing',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: 'children',
      //   id: 'area',
      //   name: 'area',
      //   col: '1'
      // },
      // {
      //   type: getType('need_help_person_familyHouse', 'select'),
      //   label: '家庭房产',
      //   options: [
      //     {
      //       label: '无',
      //       value: '无'
      //     },
      //     {
      //       label: '一处',
      //       value: '一处'
      //     },
      //     {
      //       label: '二处',
      //       value: '二处'
      //     },
      //     {
      //       label: '二处以上',
      //       value: '二处以上'
      //     }
      //   ],
      //   col: '8',
      //   defaultValue: formData.need_help_person_familyHouse || '',
      //   id: 'need_help_person_familyHouse',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: getType('need_help_person_familyMoney', 'input'),
        label: '人均年收入',
        col: '8',
        defaultValue: formData.need_help_person_familyMoney || moren,
        id: 'need_help_person_familyMoney',
        rules: [
          {
            pattern: /^(([0-9]+.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*.[0-9]+)|([0-9]*[1-9][0-9]*)|0)$/,
            message: '请输入数字'
          }
        ],
        suffix: '元',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'text',
        id: 'need_help_person_family_list',
        label: '成员列表',
        name: 'familyPerson',
        col: '24',
        layout: {
          labelCol: '120px'
        }
      }
      // {
      //   type: getType('need_help_person_remark', 'textarea'),
      //   label: '备注',
      //   col: '24',
      //   defaultValue: formData.need_help_person_remark,
      //   id: 'need_help_person_remark',
      //   autoSize: { minRows: 5, maxRows: 8 },
      //   layout: {
      //     labelCol: '120px'
      //   }
      // }
      // {
      //   type: 'text',
      //   id: 'itemRelated',
      //   label: '项目关联',
      //   name: 'itemRelated',
      //   col: '18',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      // {
      //   type: 'text',
      //   id: 'assitLog',
      //   label: '帮扶日志',
      //   name: 'assitLog',
      //   col: '18',
      //   layout: {
      //     labelCol: '120px'
      //   }
      // }
    ]
    const newData = []
    for (let i = 0; i < data.length; i++) {
      if (extend.checkDisplay(data[i].id)) {
        newData.push(data[i])
      }
    }
    return newData
  },
  getPeopleForm(extend) {
    const data = [
      {
        type: 'input',
        label: '成员姓名',
        col: '24',
        id: 'need_help_person_family_name',
        rules: [
          {
            pattern: /^[\u4e00-\u9fa5]{2,6}$/,
            message: '请输入中文长度不超过6个字符'
          },
          {
            required: true,
            message: '请填写姓名'
          }
        ],
        // defaultValue: extend.familyPeopleName,
        layout: {
          labelCol: '80px'
        }
      },
      {
        type: 'select',
        label: '关系',
        col: '24',
        options: [
          {
            label: '父亲',
            value: '父亲'
          },
          {
            label: '母亲',
            value: '母亲'
          },
          {
            label: '子女',
            value: '子女'
          },
          {
            label: '配偶',
            value: '配偶'
          },
          {
            label: '其他亲属',
            value: '其他亲属'
          }
        ],
        id: 'need_help_person_family_relation',
        // defaultValue: extend.familyPeopleRelate,
        layout: {
          labelCol: '80px'
        }
      },
      // {
      //   type: 'select',
      //   label: '性别',
      //   col: '24',
      //   id: 'need_help_person_family_gender',
      //   // defaultValue: [extend.familyPeopleSex],
      //   options: [
      //     {
      //       label: '男',
      //       value: '男'
      //     },
      //     {
      //       label: '女',
      //       value: '女'
      //     }
      //   ],
      //   layout: {
      //     labelCol: '80px'
      //   }
      // },
      {
        type: 'input',
        label: '身份证号',
        col: '24',
        rules: [
          {
            required: true,
            message: '身份证号不能为空'
          },
          {
            validator: extend.checkIdCard
          }
        ],
        // defaultValue: extend.familyPeopleIdCard,
        id: 'need_help_person_family_number_id',
        layout: {
          labelCol: '80px'
        }
      },
      {
        type: 'input',
        label: '年龄',
        col: '24',
        id: 'need_help_person_family_gender',
        // defaultValue: [extend.familyPeopleSex],
        layout: {
          labelCol: '80px'
        }
      },
      {
        type: 'input',
        label: '单位（学校）名称',
        col: '24',
        id: 'need_help_person_family_school',
        // defaultValue: [extend.familyPeopleSex],
        layout: {
          labelCol: '80px'
        }
      },
      {
        type: 'input',
        label: '年收入',
        col: '24',
        suffix: '万元',
        rules: [
          {
            pattern: /^(([0-9]+.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*.[0-9]+)|([0-9]*[1-9][0-9]*)|0)$/,
            message: '请输入数字'
          }
        ],
        // defaultValue: extend.familyPeopleIdCard,
        id: 'need_help_person_family_income',
        layout: {
          labelCol: '80px'
        }
      }
    ]
    return data
  }
}
